import { RadioButton } from 'components/1-atoms/RadioButton';
import { useState } from 'react';
import { ExciseDutyResult, formatCurrency } from '../ExciseDutyResult';
import styles from './DutySettings.module.scss';

export const CoffeeDuty = () => {
	const [rate, setRate] = useState<number>(null);

	const rateInfo = rate !== null ? `Sats: ${formatCurrency(rate)} pr. kg.` : null;
	const calculator = (ammount: number) => (rate ? (rate * ammount) / 1000 : null);

	return (
		<>
			<div className={styles.DutySettings}>
				<fieldset aria-labelledby="coffeeHeading" onChange={(e) => setRate(Number((e.target as HTMLInputElement).value))}>
					<h3 id="coffeeHeading">Type kaffe</h3>
					<RadioButton id="coffeeraw" value="6.39" name="coffeeType" label="Rå kaffe" />
					<RadioButton id="coffeebeans" value="7.67" name="coffeeType" label="Hele bønner/malet - brændt" />
					<RadioButton id="instantcoffee" value="16.61" name="coffeeType" label="Instant, pulver, flydende" />
				</fieldset>
			</div>
			<ExciseDutyResult unit="gram" container="pakker" calculator={calculator} rateInfo={rateInfo} />
		</>
	);
};
